import { useViewport } from "@faire/web/ui/hooks/useViewport";
import * as React from "react";

import HeaderSearch from "@faire/retailer/components/Header/HeaderSearch";
import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

export const MaybeMobileSearchBarXP = () => {
  const { isTabletAndAbove } = useViewport();

  if (isTabletAndAbove || !isLoggedInRetailer()) {
    return null;
  }

  return (
    <HeaderSearch
      inputId="mobile-top-search-xp"
      inputDataTestId="mobileSearchBarInput"
    />
  );
};
